import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

export const fetchBillingTerms = async (): Promise<[]> => {
  try {
    console.log("Fetching payment types...");
    const response = await axiosInstance.get("/billing-term");
    console.log("Raw response from /billing-term:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Error fetching payment types:", error.message || error);
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching the payment types."
    );
  }
};

export const useBillingTermsQuery = (): UseQueryResult<{ label: string; value: string }[]> => {
  return useQuery({
    queryKey: ["billingTerms", "all"],
    queryFn: async () => {
      const billingTerms = await fetchBillingTerms();
      return billingTerms.map((term: string) => ({ label: term, value: term }));
    },
  });
};
